import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';

const countObj = {
	init,
	play,
	loop,
	calcTop,
	el: null,

	topOffset: 0.1,
	top: 0,
	countEnd: 0,
	currentCount: 0,
	frameDuration: 0,
	duration: 1000,
	previous: 0,
	lag: 0,
	timeStart: -1,
	timeElapsed: 0
};

export default function createCounters(selector){
	selector = selector || '.js-counter';
	let elements = document.querySelectorAll(selector);
	elements = Array.prototype.slice.call(elements);

	let counters = elements.map(el => {
		let obj = Object.create(countObj);
		obj.init(el);
		return obj;
	});

	const updateCounterPlay = scroll => {
		counters.forEach(counter => {
			if(scroll >= counter.top){
				counter.play();
			}
		});
	};

	Observable.fromEvent(window, 'scroll')
		.map(() => getCurrentTop() + window.innerHeight)
		.subscribe(updateCounterPlay);

	updateCounterPlay(getCurrentTop());

	return counters;
}

function init(element){
	this.element = element;
	const countStart = +this.element.dataset.start || 0;
	this.countEnd = +this.element.dataset.end || this.countEnd;
	this.duration = +this.element.dataset.duration || this.duration;
	this.topOffset = +this.element.dataset.topOffset || this.topOffset;
	this.currentCount = countStart;
	this.frameDuration = this.duration / (this.countEnd - countStart);
	calcTop.call(this);

	this.loop = this.loop.bind(this);
}

function play(){
	requestAnimationFrame(this.loop);
}

function calcTop(){
	const { top, height } = this.element.getBoundingClientRect();
	let offset = 0;
	if(this.topOffset < 1){
		offset = window.innerHeight * this.topOffset;
	}else{
		offset = this.topOffset;
	}
	this.top = top + height + offset + getCurrentTop();
}

function incrementCount(done = false){
	if(!done){
		if(this.currentCount > this.countEnd){
			return;
		}
		this.element.innerHTML = this.currentCount++;
	}else{
		this.element.innerHTML = this.countEnd;
	}
}

function loop(){
	if(this.timeStart == -1){
		this.timeStart = window.performance.now();
		this.previous = this.timeStart;
	}

	const now = window.performance.now();
	var delta = now - this.previous;

	this.timeElapsed = now - this.timeStart;

	this.lag += delta;

	if(this.lag >= this.frameDuration){
		let increNum = Math.floor(this.lag / this.frameDuration);
		for(let i = 0; i < increNum; i++){
			incrementCount.call(this);
		}
		this.lag -= this.frameDuration * increNum;
	}

	this.previous = now;

	if(this.timeElapsed < this.duration && this.currentCount < this.countEnd){
		requestAnimationFrame(this.loop);
	}else{
		incrementCount.call(this, true);
	}
}

function getCurrentTop(){
	return window.scrollY || window.pageYOffset;
}



// WEBPACK FOOTER //
// ./node_modules/ui-counter/app/js/src/counter/index.js